<template>
  <div class="tab-pane fade show active" id="nav-5-3-primary-ver--1" role="tabpanel">
        <!-- Accordion -->
        <span v-on:click="toggleCollapse(collapseStatus)" class="pull-right" style=""><a class="g-font-size-12" v-if="collapseStatus == false">Expand All </a><a class="g-font-size-12" v-if="collapseStatus == true">Collapse All</a></span>
        <h3 class="g-color-main">Track Order</h3>
        <div style="background-color: #26304d; height: 3px; margin-bottom: 10px"></div>
        <div v-for="(group, index) in groups" id="accordion-12-1" class="u-accordion u-accordion-color-primary" role="tablist" aria-multiselectable="true">
            <!-- Card -->
            <div class="card g-brd-none rounded-0" :class="{'g-bg-secondary': ((index % 2) == 1)}">
            <div id="accordion-12-1-heading-01" class="u-accordion__header g-color-text g-font-weight-500" role="tab">
                <h5 class="mb-0">
                <a v-on:click="changeCollapse(group)" class="d-block g-color-text g-font-size-20--md g-font-size-17  g-color-primary--hover g-text-underline--none--hover g-pa-12"  data-toggle="collapse" data-parent="#accordion-12-1" aria-expanded="true" aria-controls="accordion-12-1-body-01">
                    {{group.name}}
                </a>
                </h5>
            </div>
            <div v-show="group.open" id="accordion-12-1-body-01" class="collapsed show" role="tabpanel" aria-labelledby="accordion-12-1-heading-01">
                <div class="u-accordion__body g-color-text g-pa-30 g-pt-0">
                <span class="g-font-size-20--md g-font-size-17" v-html="group.items"></span> 
                </div>
            </div>
            </div>
            <!-- End Card -->
        </div>
        <!-- End Accordion -->
    </div>
</template>
<script>
export default {
    data () {
    return {
        collapseStatus: false,
        groups: [
            {
                "name": "What is the turn-time of an order processed through Changing Life through Lenses\u2122?",
                "open": false,
                "items": "Most orders will be delivered within 2-3 weeks from the date you submit your order or from the date the lab receives the frame for Frame-to-Come orders. If you have made a Special Request, your order is not submitted to the laboratory until Essilor Vision Foundation approves or declines the request. Including a Special Request may increase the time for production."
            },
            {
                "name": "Why does my order status say “Error”?",
                "open": false,
                "items": "This means there was an issue submitting your order to the lab. Essilor Vision Foundation is aware of any orders with this error status and should review your order within 2-3 business days."
            },
            {
                "name": "What is a Pending Order?",
                "open": false,
                "items": "A Pending Order is an order that is saved but not yet submitted to the lab. You may choose to save an order as Pending if you need to locate more information before submitting the order. You may also save an order as Pending if you know you will not be able to send the frame to the lab within the next few days."
            },
            {
                "name": "Can I make a change or cancel an order that I’ve already submitted?",
                "open": false,
                "items": "Unfortunately, there is no way to edit an order once it has been submitted to the lab. If you notice that a mistake was made on your order within 48 hours of ordering, please select the “Request Cancellation” button on the Order Confirmation page for that order (accessible by clicking the SP number). Once the initial order has been cancelled, you can resubmit the order with the correct information."
            },
            {
                "name": "What do I do after submitting an order that is Pending Approval?",
                "open": false,
                "items": "If you have made a special request on the Order page and selected “Submit for Approval”, your order is Pending Approval by Essilor Vision Foundation. You will receive notice via email within a week. If approved, your notice will contain the confirmed Order Summary. At that time you can print the Order Summary and send the frame to the lab if it is a frame-to-come order. Please DO NOT send the frame without the printed Order Summary."
            },
            {
                "name": "What if there is an error on the order I received?",
                "open": false,
                "items": "If you have received an order with an error, please select the “Remake/Redo” button on the Order Confirmation page for that order (accessible by clicking the SP number). This will populate an Order form with all order information to which you can make minor edits, as necessary, and select Submit button at the bottom of the page."
            },
            {
                "name": "What does the “Export File with Current Filters” button mean?",
                "open": false,
                "items": "Use this button when you want a complete download of all exams and orders into a CSV file for reporting. This file can be opened in Excel. Most of the additional information entered on the Order page can be found in this download, such as: Referral Organization, Voucher Number/Code, Prescribing Doctor etc.) for you to more easily sort and filter. "
            },
        ]
    }
    },
    methods: {
        toggleCollapse(collapseStatus) {
            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(element => {
                element.open = this.collapseStatus;
            });
        },        
        changeCollapse(group) {
            this.groups.forEach(element => {
                element.open = false;
            });
            group.open = true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// TrackOrder.vue?c6404a56